import { ExternalLink, type ExternalLinkProps } from '@repo/design-system-kit';
import type { DistributiveOmit } from '#types/utils';
import { getTNCLink, type TNCKey } from '#utils/get-tnc-link';

export type TNCLinkProps = DistributiveOmit<ExternalLinkProps, 'href'> & {
  tncKey: TNCKey;
  language?: string;
  country?: string;
};

export function TNCLink({ tncKey, language, country, ...props }: TNCLinkProps) {
  const href = getTNCLink(tncKey, { language, country });

  if (!href) {
    return null;
  }

  return (
    <ExternalLink
      data-testid={`tnc-link-${tncKey}`}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    />
  );
}
